module.exports = __webpack_public_path__ + "static/media/greghelp.62fcc7e7.png";